import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiCard-root': {
            background: '#F75D59'
        },
        marginBottom: theme.spacing(2)
    },
}));

export default useStyles;
